<template>
  <f7-page ptr @ptr:refresh="getSensorConfig">
    <navbar title="Sensor" back-link="Tillbaka"></navbar>
    <f7-block>
      <f7-list form>
        <f7-list-input label="Högtemp (°C)" type="number" step="0.1" min="-120" max="180" :value="sensorConfig.sensorHighLimit" @input="sensorConfig.sensorHighLimit = $event.target.value"></f7-list-input>
        <f7-list-input label="Fördröjning (minuter)" type="number" step="1" min="0" max="35654" :value="sensorConfig.sensorHighDelay" @input="sensorConfig.sensorHighDelay = $event.target.value"></f7-list-input>
        <f7-list-input label="Lågtemp (°C)" type="number" step="0.1" min="-120" max="180" :value="sensorConfig.sensorLowLimit" @input="sensorConfig.sensorLowLimit = $event.target.value"></f7-list-input>
        <f7-list-input label="Fördröjning (minuter)" type="number" step="1" min="0" max="35654" :value="sensorConfig.sensorLowDelay" @input="sensorConfig.sensorLowDelay = $event.target.value"></f7-list-input>
        <f7-block>
          <f7-button fill raised @click="setSensorConfig" :disabled="saving">{{ submitText }}</f7-button>
        </f7-block>
      </f7-list>
    </f7-block>
  </f7-page>
</template>

<script>

function parseSensorConfig(sensorConfig) {
  const { sensorHighLimit, sensorHighDelay, sensorLowLimit, sensorLowDelay } = sensorConfig
  return {
    sensorHighLimit: (sensorHighLimit / 10).toFixed(1),
    sensorHighDelay,
    sensorLowLimit: (sensorLowLimit / 10).toFixed(1),
    sensorLowDelay
  }
}

let evtSource 
export default {
  data() {
    return {
      sensorConfig: {
        sensorHighLimit: null,
        sensorHighDelay: null,
        sensorLowLimit: null,
        sensorLowDelay: null,
      },
      saving: false,
    }
  },
  computed: {
    isAdmin() {
      return this.$f7.data.user && this.$f7.data.user.admin
    },
    unitId() {
      return this.$f7route.params.unitId
    },
    submitText() {
      return !this.saving ? 'Spara' : 'Sparar..'
    }
  },
  mounted() {
    this.getSensorConfig()
  },
  methods: {
    getSensorConfig(event, done) {
      const app = this.$f7
      const instance = this
      app.dialog.preloader('Laddar..')

      this.$request.json(`/api/units/${this.unitId}/sensorConfig`, (data, status) => {
        app.dialog.close()
        if (done) done()
        if (data.sensorConfig) {
          this.sensorConfig = parseSensorConfig(data.sensorConfig)
        }
      }, (xhr, status) => {
        app.dialog.close()
        if (done) done()
        if (status === 401) {
          app.dialog.alert('Du har inte åtkomst')
        } else {
          app.dialog.alert('Något gick fel')
        }
      })
    },
    setSensorConfig() {
      const instance = this
      const app = this.$f7
      instance.saving = true

      const data = {
        sensorHighLimit: this.sensorConfig.sensorHighLimit * 10,
        sensorHighDelay: this.sensorConfig.sensorHighDelay,
        sensorLowLimit: this.sensorConfig.sensorLowLimit * 10,
        sensorLowDelay: this.sensorConfig.sensorLowDelay
      }

      this.$request({
        url: `/api/units/${this.unitId}/sensorConfig`,
        method: 'PUT',
        dataType: 'json',
        data,
        success(data, status) {
          if (data.sensorConfig) {
            instance.sensorConfig = parseSensorConfig(data.sensorConfig)
          }
          app.popup.close()
        },
        error(xhr, status) {
          if (status === 401) {
            app.dialog.alert('Du har inte åtkomst')
          } else {
            app.dialog.alert('Något gick fel')
          }
        },
        complete(xhr, status) {
          instance.saving = false
        }
      })
    },
  }
}

</script>